import { useRestoreTournamentMutation } from '../../Queries/Tournaments'
import { navigateToEditTournamentPage } from '../../Scenes/navigators'
import { ArchiveRestoreEventModal } from '../_common/ArchiveEvent/ArchiveRestoreEventModal'

export const ArchiveRestoreTournamentModal = (props) => {
  const { eventId, ...rest } = props
  const { mutate: restoreTournament } = useRestoreTournamentMutation(eventId)
  const navigateToEdit = () => navigateToEditTournamentPage(eventId)

  return (
    <ArchiveRestoreEventModal
      handleConfirm={restoreTournament}
      navigateToEdit={navigateToEdit}
      {...rest}
    />
  )
}
